import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './views/login/login.component';
import { AuthRoutingModule } from './auth-routing.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { ErrorComponent } from './views/error/error.component';
import { ResetComponent } from './views/reset/reset.component';
import { ForgotComponent } from './views/forgot/forgot.component';
import { SignupEmailComponent } from './views/signup-email/signup-email.component';
import { SignupCodeComponent } from './views/signup-code/signup-code.component';
import { SignupPasswordComponent } from './views/signup-password/signup-password.component';



@NgModule({
  declarations: [
    LoginComponent,
    ErrorComponent,
    ResetComponent,
    ForgotComponent,
    SignupEmailComponent,
    SignupCodeComponent,
    SignupPasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AuthRoutingModule,
    SharedModule,
  ]
})

export class AuthModule { }
